<div style="position: absolute; left: -15420px">
  <div id="salesOrderBulkPrint">
    <div
      class="sales-order-invoice-page"
      *ngFor="let inv of invoiceList"
      style="width: 100%; display: flex"
    >
      <div style="width: 100%; display: flex">
        <div class="container" style="width: 80%; margin-right: auto; margin-left: auto">
          <div class="brand-section" style="margin-bottom: 10px">
            <div class="row" style="display: flex; flex-wrap: wrap; align-items: flex-start">
              <div class="col-4" style="width: 33%; flex: 0 0 auto">
                <b>{{ companyProfile?.title }}</b><br />
                <span *ngIf="companyProfile?.address">{{ companyProfile.address }}<br /></span>
                <span *ngIf="companyProfile?.phone">{{ companyProfile.phone }}</span>
              </div>
              <div class="col-4" style="width: 34%; flex: 0 0 auto"></div>
              <div class="col-4" style="width: 33%; flex: 0 0 auto; text-align: right">
                <img
                  class="img-fluid"
                  style="max-height: 50px"
                  [src]="getCompanyLogoUrl()"
                />
              </div>
            </div>
          </div>

          <div class="body-section" style="padding: 10px 10px 0 10px; margin-top: 10px">
            <div class="row" style="display: flex; flex-wrap: wrap">
              <div class="col-6" style="width: 50%; flex: 0 0 auto">
                <div>
                  <span>{{ "ORDER_NUMBER" | translate }}:</span>
                  {{ inv.order?.orderNumber }}
                </div>
                <div style="font-size: 14px; margin-top: 2px">
                  <span>Order Type:</span>
                  {{ inv.order?.orderType?.name }}
                </div>
                <div>
                  <span>Order Date:</span>
                  {{ inv.order?.orderDate | utcToLocalTime : "shortDate" }}
                </div>
                <div>
                  <span>Written By Rep:</span>
                  {{ inv.order?.placeByRep?.firstName }} {{ inv.order?.placeByRep?.lastName }}
                  ({{ inv.order?.placeByRepCommissionPercentage }}%)
                </div>
                <div>
                  <span>Written For Rep:</span>
                  {{ inv.order?.writtenForRep?.firstName }} {{ inv.order?.writtenForRep?.lastName }}
                  ({{ inv.order?.writtenForCommissionPercentage }}%)
                </div>
                <div>
                  <span>{{ "PO_NUMBER" | translate }}:</span>
                  {{ inv.order?.poNumber }}
                </div>
                <div *ngIf="inv.order?.terms" style="font-weight: bold; margin-top: 4px">
                  <span>{{ "TERM_AND_CONDITION" | translate }}:</span>
                  {{ inv.order.terms.name }}
                </div>
              </div>
              <div class="col-6" style="width: 50%; flex: 0 0 auto">
                <div>
                  <span>{{ "MARKET" | translate }}:</span>
                  {{ inv.order?.marketOrder?.marketName }}
                </div>
                <div>
                  <span>{{ "CUSTOMER_NUMBER" | translate }}:</span>
                  {{ inv.order?.customer?.customerNumber }}
                  <span *ngIf="inv.order?.customer?.customerName">
                    ({{ inv.order?.customer?.customerName }})
                  </span>
                </div>
                <div>
                  <span>Delivery Mode:</span>
                  {{ DeliveryMode[inv.order?.deliveryType] }}
                </div>
                <div>
                  <span>Ship Date:</span>
                  {{ inv.order?.shipDate | utcToLocalTime : "shortDate" }}
                </div>
                <div>
                  <span>Ship Via:</span>
                  {{ inv.order?.shipVia }}
                </div>
                <div>
                  <span>Do Not Ship Before:</span>
                  {{ inv.order?.doNotShipBeforeDate | utcToLocalTime : "shortDate" }}
                </div>
              </div>
            </div>
          </div>

          <div
            class="body-section"
            style="padding: 10px 10px 20px 20px; border: 1px solid gray; margin-top: 10px"
          >
            <div class="row" style="display: flex; flex-wrap: wrap">
              <div class="col-6" style="width: 50%; flex: 0 0 auto">
                <h4 class="heading" style="margin-bottom: 2px">Bill To,</h4>
                <b>{{ getBillToName(inv.order) }}</b><br />
                <div *ngIf="getBillToAddressLine(inv.order)">
                  {{ getBillToAddressLine(inv.order) }}<br />
                </div>
                <div style="margin-top: 2px">
                  <div *ngIf="getBillToPhone(inv.order)">
                    <b>Phone:</b> {{ getBillToPhone(inv.order) }}<br />
                  </div>
                  <div *ngIf="getBillToFax(inv.order)">
                    <b>Fax:</b> {{ getBillToFax(inv.order) }}<br />
                  </div>
                  <div *ngIf="getBillToEmail(inv.order)">
                    <b>Email:</b> {{ getBillToEmail(inv.order) }}
                  </div>
                </div>
              </div>
              <div class="col-6" style="width: 50%; flex: 0 0 auto">
                <h4 class="heading" style="margin-bottom: 2px">Ship To,</h4>
                <b>{{ getShipToName(inv.order) }}</b><br />
                <div *ngIf="getShipToAddressLine(inv.order)">
                  {{ getShipToAddressLine(inv.order) }}<br />
                </div>
                <div style="margin-top: 2px">
                  <div *ngIf="getShipToPhone(inv.order)">
                    <b>Phone:</b> {{ getShipToPhone(inv.order) }}<br />
                  </div>
                  <div *ngIf="getShipToFax(inv.order)">
                    <b>Fax:</b> {{ getShipToFax(inv.order) }}<br />
                  </div>
                  <div *ngIf="getShipToEmail(inv.order)">
                    <b>Email:</b> {{ getShipToEmail(inv.order) }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="body-section" style="padding: 16px; border: 1px solid gray">
            <h4 class="heading" style="margin-top: 2px">
              {{ "SALES_ORDER_ITEMS" | translate }}
            </h4>
            <table
              class="table-bordered"
              style="
                background-color: #fff;
                width: 100%;
                border-collapse: collapse;
                box-shadow: 0px 0px 5px 0.5px gray;
              "
            >
              <thead>
                <tr style="border: 1px solid #111; background-color: #f2f2f2">
                  <th style="padding-top: 08px; padding-bottom: 08px; border: 1px solid #dee2e6; width: 5%">
                    {{ "NO." | translate }}
                  </th>
                  <th style="padding-top: 08px; padding-bottom: 08px; border: 1px solid #dee2e6; width: 10%">
                    Item
                  </th>
                  <th style="padding-top: 08px; padding-bottom: 08px; border: 1px solid #dee2e6; width: 20%">
                    {{ "DESCRIPTION" | translate }}
                  </th>
                  <th style="padding-top: 08px; padding-bottom: 08px; border: 1px solid #dee2e6; width: 12%">
                    {{ "UNIT_PRICE" | translate }}
                  </th>
                  <th style="padding-top: 08px; padding-bottom: 08px; border: 1px solid #dee2e6; width: 8%">
                    {{ "QUANTITY" | translate }}
                  </th>
                  <th style="padding-top: 08px; padding-bottom: 08px; border: 1px solid #dee2e6; width: 15%">
                    {{ "NOTES" | translate }}
                  </th>
                  <th style="padding-top: 08px; padding-bottom: 08px; border: 1px solid #dee2e6; width: 15%">
                    {{ "TAX" | translate }}
                  </th>
                  <th style="padding-top: 08px; padding-bottom: 08px; border: 1px solid #dee2e6; width: 15%">
                    {{ "TOTAL_AMOUNT" | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let salesItem of inv.items; let i = index">
                  <td style="vertical-align: middle !important; text-align: center; border: 1px solid #dee2e6">
                    {{ i + 1 }}
                  </td>
                  <td style="vertical-align: middle !important; text-align: center; border: 1px solid #dee2e6">
                    <img
                      *ngIf="getProductImageUrl(salesItem)"
                      [src]="getProductImageUrl(salesItem)"
                      alt=""
                      style="max-width: 50px; max-height: 50px; object-fit: contain"
                    />
                  </td>
                  <td style="vertical-align: middle !important; text-align: center; border: 1px solid #dee2e6">
                    {{ salesItem.description || salesItem.productName }}
                  </td>
                  <td style="vertical-align: middle !important; text-align: center; border: 1px solid #dee2e6">
                    {{ (salesItem.overridePrice || salesItem.unitPrice) | customCurrency }}
                  </td>
                  <td style="vertical-align: middle !important; text-align: center; border: 1px solid #dee2e6">
                    {{ salesItem.displayQuantity || salesItem.quantity }}<br />
                    <span style="font-size: 10px" *ngIf="salesItem?.unitName">({{ salesItem.unitName }})</span>
                  </td>
                  <td style="vertical-align: middle !important; text-align: center; border: 1px solid #dee2e6">
                    {{ salesItem.notes }}
                  </td>
                  <td style="vertical-align: middle !important; text-align: center; border: 1px solid #dee2e6">
                    {{ salesItem.taxValue | customCurrency }}<br />
                    <span style="font-size: 10px" *ngFor="let tax of salesItem.salesOrderItemTaxes; let last = last">
                      {{ tax.taxName }}({{ tax.taxPercentage }}%)
                      <span *ngIf="!last">, </span>
                    </span>
                  </td>
                  <td style="vertical-align: middle !important; text-align: center; border: 1px solid #dee2e6">
                    {{
                      salesItem?.quantity * (salesItem.overridePrice || salesItem?.unitPrice) -
                        salesItem.discount +
                        salesItem.taxValue | customCurrency
                    }}
                  </td>
                </tr>
                <tr
                  style="vertical-align: middle !important; border: 1px solid #dee2e6; background-color: blanchedalmond"
                  *ngIf="inv.returnItems.length > 0"
                >
                  <td colspan="8">
                    <strong>{{ "RETURNED_ITEMS" | translate }}</strong>
                  </td>
                </tr>
                <tr style="background-color: blanchedalmond" *ngFor="let salesItem of inv.returnItems; let i = index">
                  <td style="vertical-align: middle !important; text-align: center; border: 1px solid #dee2e6">
                    {{ i + 1 }}
                  </td>
                  <td style="vertical-align: middle !important; text-align: center; border: 1px solid #dee2e6">
                    <img
                      *ngIf="getProductImageUrl(salesItem)"
                      [src]="getProductImageUrl(salesItem)"
                      alt=""
                      style="max-width: 50px; max-height: 50px; object-fit: contain"
                    />
                  </td>
                  <td style="vertical-align: middle !important; text-align: center; border: 1px solid #dee2e6">
                    {{ salesItem.description || salesItem.productName }}
                  </td>
                  <td style="vertical-align: middle !important; text-align: center; border: 1px solid #dee2e6">
                    {{ (salesItem.overridePrice || salesItem.unitPrice) | customCurrency }}
                  </td>
                  <td style="vertical-align: middle !important; text-align: center; border: 1px solid #dee2e6">
                    {{ salesItem.displayQuantity || salesItem.quantity }}<br />
                    <span style="font-size: 10px">({{ salesItem.unitName }})</span>
                  </td>
                  <td style="vertical-align: middle !important; text-align: center; border: 1px solid #dee2e6">
                    {{ salesItem.notes }}
                  </td>
                  <td style="vertical-align: middle !important; text-align: center; border: 1px solid #dee2e6">
                    {{ salesItem.taxValue | customCurrency }}<br />
                    <span style="font-size: 10px" *ngFor="let tax of salesItem.purchaseOrderItemTaxes; let last = last">
                      {{ tax.taxName }}({{ tax.taxPercentage }}%)
                      <span *ngIf="!last">, </span>
                    </span>
                  </td>
                  <td style="vertical-align: middle !important; text-align: center; border: 1px solid #dee2e6">
                    {{
                      salesItem?.quantity * (salesItem.overridePrice || salesItem?.unitPrice) -
                        salesItem.discount +
                        salesItem.taxValue | customCurrency
                    }}
                  </td>
                </tr>
                <tr>
                  <td colspan="6" style="border: none"></td>
                  <td style="text-align: right; font-weight: bold; border: 1px solid #dee2e6">Shipping Charge</td>
                  <td style="text-align: center; border: 1px solid #dee2e6">
                    {{ (inv.order?.totalShippingCost || 0) | customCurrency }}
                  </td>
                </tr>
                <tr>
                  <td colspan="6" style="border: none"></td>
                  <td style="text-align: right; font-weight: bold; border: 1px solid #dee2e6">Discount Amount</td>
                  <td style="text-align: center; border: 1px solid #dee2e6">
                    {{ inv.order.totalDiscount | customCurrency }}
                  </td>
                </tr>
                <tr>
                  <td colspan="6" style="border: none"></td>
                  <td style="text-align: right; font-weight: bold; border: 1px solid #dee2e6">Upcharge Amount</td>
                  <td style="text-align: center; border: 1px solid #dee2e6">
                    {{ inv.order.totalUpcharge | customCurrency }}
                  </td>
                </tr>
                <tr>
                  <td colspan="6" style="border: none"></td>
                  <td style="text-align: right; font-weight: bold; border: 1px solid #dee2e6">{{ "PAID" | translate }}</td>
                  <td style="text-align: center; border: 1px solid #dee2e6">
                    {{ inv.order.totalPaidAmount | customCurrency }}
                  </td>
                </tr>
                <tr>
                  <td colspan="6" style="border: none"></td>
                  <td style="text-align: right; font-weight: bold; border: 1px solid #dee2e6">{{ "BALANCE" | translate }}</td>
                  <td style="text-align: center; border: 1px solid #dee2e6">
                    {{ inv.order.totalAmount - inv.order.totalPaidAmount | customCurrency }}
                  </td>
                </tr>
                <tr style="font-weight: bold">
                  <td colspan="4" style="border: none"></td>
                  <td style="text-align: center; border: 1px solid #dee2e6">{{ inv.order.totalQuantity }}</td>
                  <td style="text-align: center; border: 1px solid #dee2e6"></td>
                  <td style="text-align: center; border: 1px solid #dee2e6">{{ inv.order.totalTax | customCurrency }}</td>
                  <td style="text-align: center; border: 1px solid #dee2e6">{{ inv.order.totalAmount | customCurrency }}</td>
                </tr>
              </tbody>
            </table>
            <div *ngIf="inv.order.terms" style="display: flex; flex-wrap: wrap; margin-top: 20px">
              <h5 class="heading" style="margin-top: 2px">{{ "TERM_AND_CONDITION" | translate }}::</h5>
              {{ inv.order.terms.name }}
            </div>
            <div style="display: flex; flex-wrap: wrap; margin-top: 20px">
              <h5 class="heading" style="margin-top: 2px">{{ "NOTES" | translate }}::</h5>
              {{ inv.order.notes }}
            </div>
            <div style="display: flex; flex-wrap: wrap; margin-top: 20px">
              {{ "PAYMENT_STATUS" | translate }}:{{ inv.order.paymentStatus | paymentStatus }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
